export const setLoginStats = 'setLoginStats';
export const setChatStats = 'setChatStats';
export const updateChatStats = 'updateChatStats';
export const setChatId = 'setChatId';
export const setChatState = 'setChatState';
export const setModelState = 'setModelState';
export const setSidebarState = 'setSidebarState';
export const setchatHistoryState = 'setchatHistoryState';
export const setchatCountState = 'setchatCountState';
export const setLogin = login => dispatch => {
    dispatch({
        type: setLoginStats,
        payload: login
    });

};

export const setChat = chat => dispatch => {
    dispatch({
        type: setChatStats,
        payload: chat
    });

};

export const updateChat = chat => dispatch => {
    dispatch({
        type: updateChatStats,
        payload: chat
    });

};

export const ChatID = chat => dispatch => {
    dispatch({
        type: setChatId,
        payload: chat
    });

};

export const ChatState = chat => dispatch => {
    dispatch({
        type: setChatState,
        payload: chat
    });

};

export const modelState = chat => dispatch => {
    dispatch({
        type: setModelState,
        payload: chat
    });

};

export const sidebarState = chat => dispatch => {
    dispatch({
        type: setSidebarState,
        payload: chat
    });

};

export const chatHistoryState = chat => dispatch => {
    dispatch({
        type: setchatHistoryState,
        payload: chat
    });

};

export const chatCountState = chat => dispatch => {
    dispatch({
        type: setchatCountState,
        payload: chat
    });

};